import { AppEntrypoint } from "../typings/enums";

export type WrongAppRedirectDestination = "legacy" | "fh_plus_rn";

export type AppEntrypointValidationResult =
  | { isValid: true }
  | {
      isValid: false;
      header: string;
      body: string;
      link: string;
      redirectDestination: WrongAppRedirectDestination;
    };

// Rendered as a toast headline + body with a "Download App" button
// (see Login.tsx). The button owns the action — no inline link in body.
const WRONG_APP_HEADER = "This isn't the right app for your account";

const FH_PLUS_RN_BODY =
  "Your FuturHealth account is set up on our FuturHealth+ mobile app. Download it to sign in and access your care.";

const LEGACY_BODY =
  "Your FuturHealth account is set up on our FuturHealth mobile app. Download it to sign in and access your care.";

const LEGACY_ONELINK =
  "https://futurhealth.onelink.me/7AzR/?pid=ionic_web_redirect&c=app_entrypoint_redirect&af_channel=wrong_app_error_message&deep_link_sub1=legacy";

const FH_PLUS_RN_ONELINK =
  "https://futurhealth.onelink.me/DU99/ww2qiihk?pid=ionic_web_redirect&c=app_entrypoint_redirect&af_channel=wrong_app_error_message&deep_link_sub1=fh_plus_rn";

// Mirrors the FH RN app_entrypoint check (see funnel-cms/apps/mobile/src/utils/appEntrypoint.ts).
// Only fh_plus_web belongs on Ionic; anything else is a wrong-app login.
// Unknown/undefined values fall through to the fh_plus_rn destination — no legacy fallback.
export const validateAppEntrypoint = (
  appEntrypoint: AppEntrypoint | string | undefined
): AppEntrypointValidationResult => {
  if (appEntrypoint === AppEntrypoint.fh_plus_web) {
    return { isValid: true };
  }

  if (appEntrypoint === AppEntrypoint.legacy_mobile) {
    return {
      isValid: false,
      header: WRONG_APP_HEADER,
      body: LEGACY_BODY,
      link: LEGACY_ONELINK,
      redirectDestination: "legacy",
    };
  }

  return {
    isValid: false,
    header: WRONG_APP_HEADER,
    body: FH_PLUS_RN_BODY,
    link: FH_PLUS_RN_ONELINK,
    redirectDestination: "fh_plus_rn",
  };
};
